import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5be5ba60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid px-5 py-4" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "mb-3" }, "Credits", -1))
const _hoisted_5 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-spin fa-spinner me-2" }, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Loading… ")
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_10 = { class: "card shadow-sm mb-4" }
const _hoisted_11 = { class: "card-body d-flex flex-wrap align-items-center gap-4" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted small" }, "Available balance", -1))
const _hoisted_13 = { class: "display-6 mb-0" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted small" }, "Next credit lot expires", -1))
const _hoisted_16 = { class: "mb-0" }
const _hoisted_17 = { class: "text-muted small" }
const _hoisted_18 = {
  key: 0,
  class: "card shadow-sm mb-4"
}
const _hoisted_19 = { class: "card-header bg-transparent d-flex flex-wrap align-items-center justify-content-between gap-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Workspace subscription", -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Manage subscription ")
const _hoisted_22 = { class: "card-body d-flex flex-wrap gap-4" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted small" }, "Current plan", -1))
const _hoisted_24 = { class: "mb-1 fw-semibold" }
const _hoisted_25 = { class: "badge text-bg-secondary text-capitalize" }
const _hoisted_26 = { class: "text-muted small" }
const _hoisted_27 = { class: "mb-0 fw-semibold" }
const _hoisted_28 = { class: "text-muted small" }
const _hoisted_29 = { class: "mb-0" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted small" }, "Last billing", -1))
const _hoisted_32 = { class: "mb-1" }
const _hoisted_33 = {
  key: 0,
  class: "small text-danger mb-0 mt-2"
}
const _hoisted_34 = { class: "card shadow-sm mb-4" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-transparent" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Credit bundles")
], -1))
const _hoisted_36 = { class: "card-body" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted small mb-4 mb-md-3" }, " One-off purchases added to your workspace balance. Bundle credits are valid for 12 months from purchase and are used after subscription credits (first expiring, first out). ", -1))
const _hoisted_38 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_39 = {
  key: 1,
  class: "text-muted py-2"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-spin fa-spinner me-2" }, null, -1))
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Loading bundles… ")
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = {
  key: 2,
  class: "alert alert-warning mb-0"
}
const _hoisted_44 = {
  key: 3,
  class: "row g-4"
}
const _hoisted_45 = { class: "bundle-card h-100" }
const _hoisted_46 = { class: "bundle-card-title" }
const _hoisted_47 = {
  key: 0,
  class: "bundle-card-description text-muted small"
}
const _hoisted_48 = { class: "bundle-card-highlights" }
const _hoisted_49 = { class: "bundle-card-highlight" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bundle-card-highlight-label" }, "Credits", -1))
const _hoisted_51 = { class: "bundle-card-highlight-value" }
const _hoisted_52 = { class: "bundle-card-highlight" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bundle-card-highlight-label" }, "Price", -1))
const _hoisted_54 = { class: "bundle-card-highlight-value" }
const _hoisted_55 = { class: "bundle-card-validity text-muted small mb-0" }
const _hoisted_56 = { class: "bundle-card-footer mt-auto" }
const _hoisted_57 = ["href"]
const _hoisted_58 = ["disabled", "onClick"]
const _hoisted_59 = {
  key: 0,
  class: "fa fa-spin fa-spinner me-1",
  "aria-hidden": "true"
}
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" Buy ")
const _hoisted_61 = { class: "card shadow-sm" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-transparent" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Credit lots")
], -1))
const _hoisted_63 = { class: "card-body p-0" }
const _hoisted_64 = {
  key: 0,
  class: "p-4 text-muted"
}
const _hoisted_65 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_66 = { class: "table table-hover mb-0" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Source"),
    /*#__PURE__*/_createElementVNode("th", null, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Granted"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Remaining"),
    /*#__PURE__*/_createElementVNode("th", null, "Granted at"),
    /*#__PURE__*/_createElementVNode("th", null, "Expires"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Days left")
  ])
], -1))
const _hoisted_68 = { class: "badge text-bg-secondary" }
const _hoisted_69 = { class: "text-end" }
const _hoisted_70 = { class: "text-end" }
const _hoisted_71 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
          : (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.error), 1))
            : (_ctx.overview)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", null, [
                        _hoisted_12,
                        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.formatAmount(_ctx.overview.available)), 1)
                      ]),
                      (_ctx.overview.nextExpiryAt)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _hoisted_15,
                            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.formatFullDate(_ctx.overview.nextExpiryAt)), 1),
                            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.formatRemainingDays(_ctx.overview.nextExpiryAt)), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (_ctx.overview.subscription)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _hoisted_20,
                          _createVNode(_component_router_link, {
                            to: _ctx.subscriptionManageRoute,
                            class: "btn btn-sm btn-outline-primary"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_21
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", null, [
                            _hoisted_23,
                            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.overview.subscription.planLabel), 1),
                            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.overview.subscription.type), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_26, " Credits per " + _toDisplayString(_ctx.overview.subscription.renewalIntervalLabel), 1),
                            _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.formatAmount(_ctx.overview.subscription.monthlyCredits)), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.periodEndHeading), 1),
                            _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.overview.subscription.periodEndAt
                                            ? _ctx.formatFullDate(_ctx.overview.subscription.periodEndAt)
                                            : '—'), 1)
                          ]),
                          (_ctx.overview.subscription.lastBilling)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                _hoisted_31,
                                _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.overview.subscription.lastBilling.createdAt
                                            ? _ctx.formatFullDate(_ctx.overview.subscription.lastBilling.createdAt)
                                            : '—'), 1),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["badge", 
                                        _ctx.lastBillingBadgeClass(
                                            _ctx.isLastBillingSuccessful(_ctx.overview.subscription.lastBilling),
                                        )
                                    ])
                                }, _toDisplayString(_ctx.isLastBillingSuccessful(_ctx.overview.subscription.lastBilling)
                                            ? 'Successful'
                                            : 'Failed'), 3),
                                (_ctx.overview.subscription.lastBilling.failed)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, " Automatic renewal was turned off after this charge failed. You can still use the workspace until the period ends. "))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      (_ctx.bundlePurchaseError)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.bundlePurchaseError), 1))
                        : _createCommentVNode("", true),
                      (_ctx.bundlesLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, _hoisted_42))
                        : (_ctx.bundlesError)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_ctx.bundlesError), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.creditBundles, (bundle) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: bundle.sku,
                                  class: "col-12 col-sm-6 col-xl-3"
                                }, [
                                  _createElementVNode("div", _hoisted_45, [
                                    _createElementVNode("h3", _hoisted_46, _toDisplayString(bundle.label), 1),
                                    (bundle.description)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_47, _toDisplayString(bundle.description), 1))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_48, [
                                      _createElementVNode("div", _hoisted_49, [
                                        _hoisted_50,
                                        _createElementVNode("span", _hoisted_51, _toDisplayString(bundle.creditsLabel), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_52, [
                                        _hoisted_53,
                                        _createElementVNode("span", _hoisted_54, _toDisplayString(bundle.priceLabel), 1)
                                      ])
                                    ]),
                                    _createElementVNode("p", _hoisted_55, _toDisplayString(bundle.validityLabel), 1),
                                    _createElementVNode("div", _hoisted_56, [
                                      (!bundle.purchasable && bundle.contactHref)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            href: bundle.contactHref,
                                            class: "btn btn-outline-primary w-100"
                                          }, " Contact us ", 8, _hoisted_57))
                                        : (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            type: "button",
                                            class: "btn btn-primary w-100",
                                            disabled: _ctx.buyingBundleSku !== null,
                                            onClick: _withModifiers(($event: any) => (_ctx.onBuyBundle(bundle)), ["prevent"])
                                          }, [
                                            (_ctx.buyingBundleSku === bundle.sku)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_59))
                                              : _createCommentVNode("", true),
                                            _hoisted_60
                                          ], 8, _hoisted_58))
                                    ])
                                  ])
                                ]))
                              }), 128))
                            ]))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _hoisted_62,
                    _createElementVNode("div", _hoisted_63, [
                      (!_ctx.overview.lots.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_64, " No credit lots for this workspace yet. "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_65, [
                            _createElementVNode("table", _hoisted_66, [
                              _hoisted_67,
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.overview.lots, (lot) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: lot.id
                                  }, [
                                    _createElementVNode("td", null, [
                                      _createElementVNode("span", _hoisted_68, _toDisplayString(lot.source), 1)
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["badge", _ctx.statusBadgeClass(lot.status)])
                                      }, _toDisplayString(lot.status), 3)
                                    ]),
                                    _createElementVNode("td", _hoisted_69, _toDisplayString(_ctx.formatAmount(lot.grantedAmount)), 1),
                                    _createElementVNode("td", _hoisted_70, _toDisplayString(_ctx.formatAmount(lot.remainingAmount)), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.formatTableDate(lot.grantedAt)), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.formatTableDate(lot.expiresAt)), 1),
                                    _createElementVNode("td", _hoisted_71, _toDisplayString(_ctx.formatRemainingDays(lot.expiresAt)), 1)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true)
      ])
    ])
  ]))
}